module.exports = __webpack_public_path__ + "02fe34b6e936f56e60715a505440ce38.pdf";